(function () {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const visited = sessionStorage.getItem('andrew:visited') === '1';
  const root = document.documentElement;

  /** Scroll reveal for .ed-reveal — must run even when theme “reveal on scroll” (animations.js) is off. */
  function initEdReveal(rootEl) {
    const root = rootEl && typeof rootEl.getElementsByClassName === 'function' ? rootEl : document;
    const els = Array.from(root.getElementsByClassName('ed-reveal'));
    if (!els.length) return;
    const sectionIndex = new WeakMap();
    els.forEach((el) => {
      const section = el.closest('section, .shopify-section') || document.body;
      const i = sectionIndex.get(section) ?? 0;
      sectionIndex.set(section, i + 1);
      el.style.setProperty('--stagger-i', Math.min(i, 8));
      el.dataset.stagger = '';
    });
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-revealed');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px' },
    );
    els.forEach((el) => io.observe(el));
  }

  function splitScrollHeadlines(rootEl) {
    const els = Array.from((rootEl || document).querySelectorAll('[data-ed-split-scroll]'));
    if (!els.length) return;
    els.forEach((el) => {
      if (el.dataset.edSplitScrollDone) return;
      el.dataset.edSplitScrollDone = '1';
      // Snapshot child nodes to preserve <br> elements between lines
      const childNodes = Array.from(el.childNodes);
      el.innerHTML = '';
      const spans = [];
      let wordIndex = 0;
      let lastWasWord = false;
      childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          node.textContent.split(/\s+/).filter(Boolean).forEach((word) => {
            if (lastWasWord) el.appendChild(document.createTextNode(' '));
            const span = document.createElement('span');
            span.className = 'ed-split-scroll__word';
            span.textContent = word;
            span.style.setProperty('--word-i', wordIndex++);
            el.appendChild(span);
            spans.push(span);
            lastWasWord = true;
          });
        } else if (node.nodeName === 'BR') {
          el.appendChild(document.createElement('br'));
          lastWasWord = false;
        }
      });
      if (reduced) { spans.forEach((s) => s.classList.add('is-visible')); return; }
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              spans.forEach((s) => s.classList.add('is-visible'));
              io.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -12% 0px' },
      );
      io.observe(el);
    });
  }

  function splitHeadline() {
    document.querySelectorAll('[data-ed-split]').forEach((el) => {
      const text = el.textContent;
      el.textContent = '';
      // Split into words first so words stay unbroken; then letters within each
      // word get their own span for staggered rise. A trailing space is rendered
      // as a non-breaking space sibling between words.
      const words = text.split(/\s+/).filter(Boolean);
      let letterIndex = 0;
      words.forEach((word, wi) => {
        const wordEl = document.createElement('span');
        wordEl.className = 'ed-split-rise__word';
        [...word].forEach((ch) => {
          const letterEl = document.createElement('span');
          letterEl.textContent = ch;
          letterEl.style.setProperty('--letter-i', letterIndex);
          wordEl.appendChild(letterEl);
          letterIndex += 1;
        });
        el.appendChild(wordEl);
        if (wi < words.length - 1) {
          el.appendChild(document.createTextNode(' '));
        }
      });
      el.classList.add('ed-split-rise');
    });
  }

  function mountCurtain() {
    const c = document.createElement('div');
    c.className = 'ed-curtain';
    document.body.appendChild(c);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        root.dataset.loaded = 'true';
      });
    });
    setTimeout(() => c.remove(), 1200);
  }

  window.addEventListener('DOMContentLoaded', () => {
    splitHeadline();
    splitScrollHeadlines(document);
    initEdReveal(document);
    if (!visited && !reduced) mountCurtain();
    sessionStorage.setItem('andrew:visited', '1');
  });

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      splitScrollHeadlines(e.target);
      initEdReveal(e.target);
    });
  }
})();
